const o="/";export{o as URL_DIVIDER};
